import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-category-indicator',
    templateUrl: './category-indicator.component.html',
    styleUrls: ['./category-indicator.component.scss'],
    standalone: false,
})
export class CategoryIndicatorComponent {
    @Input() color: string;
    @Input() clickable = false;
    @Input() shape: 'dot' | 'square' = 'dot';
}
